import React from "react";
import { Dialog } from '@fluentui/react-northstar'
import PropTypes from "prop-types";
import Constants from "../../../constants/text-constants";

const LocationAlreadyInUseDialog = (props) => {
    const { locationDescription, onConfirm } = props;

    return (
        <Dialog
            data-testid="locationAlreadyInUseDialog"
            className="maxWidthDialog"
            confirmButton={Constants.OK}
            header={Constants.DELETE_LOCATION}
            content={Constants.UNABLE_TO_DELETE + " " + locationDescription + " " + Constants.AS_YOU_ARE_CURRENTLY_REGISTERED}
            open={true}
            onConfirm={onConfirm}
        />);
};

LocationAlreadyInUseDialog.propTypes = {
    onConfirm: PropTypes.func,
    locationDescription: PropTypes.string,
};

export default LocationAlreadyInUseDialog;
